var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bottom_container safe-padding-bottom"
  }, [_c('div', {
    staticClass: "input_wrapper",
    on: {
      "click": function click($event) {
        return _vm.handleClickBtn('comment');
      }
    }
  }, [_c('k18n', [_vm._v("Comment")])], 1), _c('div', {
    staticClass: "action_wrapper"
  }, _vm._l(_vm.config, function (item) {
    return _c('div', {
      key: item.key,
      staticClass: "action"
    }, [_c('img', {
      staticClass: "icon",
      attrs: {
        "src": item.icon,
        "alt": item.key
      },
      on: {
        "click": function click($event) {
          return _vm.handleClickBtn(item.click_type);
        }
      }
    }), _c('div', {
      staticClass: "text"
    }, [_vm._v(" " + _vm._s(_vm.formatValue(_vm.interactInfo[item.key] || 0)) + " ")])]);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }